import React from 'react';
import { shape, string, arrayOf, func } from 'prop-types';
import cx from 'classnames';

import Link from 'gatsby-link';
import { Grid } from '../';

const CLASS_ROOT = 'header';

const propTypes = {
  items: arrayOf(
    shape({
      title: string,
      href: string,
    }),
  ),
  logo: string,
  logoMobile: string,
  renderButton: func,
};

const Header = ({
  children,
  className,
  items,
  logo,
  logoMobile,
  renderButton,
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);

  const brand = logo &&
    logoMobile && [
      <Link key="logo-desktop" to="/" className="nav__logo show-m">
        {' '}
        {/* .invisible */}
        <svg>
          <use xlinkHref={`#${logo}`} />
        </svg>
      </Link>,
      <Link key="logo-mobile" to="/" className="nav__logo--mobile hide-m">
        <svg>
          <use xlinkHref={`#${logoMobile}`} />
        </svg>
      </Link>,
    ];

  const menuItems = items && (
    <ul className="list--unstyled list--inline show-m">
      {items.map((item, index) => (
        <li key={index} className="nav__item large-text">
          <Link className="no-mrg">{item.title}</Link>
        </li>
      ))}
    </ul>
  );

  const button = renderButton && renderButton();

  return (
    <nav className={classes} {...other}>
      <Grid className="nav d-flex align-items-middle">
        {brand} {menuItems} {button}
      </Grid>
    </nav>
  );
};

Header.propTypes = propTypes;

export default Header;
